import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { ColorPicker } from "../BuilderUI/ColorPicker";
import { IBuildlingBlockInputControl } from "./BuildingBlockInterfaces";

interface IColorPickerTextField extends IBuildlingBlockInputControl<string> {
    onFocus?: () => void;
}

export const UIColorPickerTextField = (props: IColorPickerTextField) => {
    let [showDialog, setShowDialog] = useState<boolean>(false);
    let [color, setColor] = useState<string | undefined>();

    useEffect(() => {
        setColor(props.value);
    }, [props.value]);

    return (
        <>
            <TextField
                fullWidth={props.fullWidth}
                sx={props.sx}
                key={"colorTextField"}
                label={props.label}
                inputProps={{ readOnly: true, onFocus: props.onFocus }}
                variant={props.variant ?? "outlined"}
                size={props.size ?? "small"}
                value={color || ""}
                onClick={() => {
                    setShowDialog(true);
                }}
                error={Boolean(props.error)}
                helperText={props.error ?? props.hint}
                InputProps={{
                    endAdornment: (
                        <Box
                            width={"20px"}
                            height={"20px"}
                            border={!color ? "1px solid " + UIStyleConstants.GRAY_COLOR : undefined}
                            bgcolor={color}
                        ></Box>
                    ),
                }}
            ></TextField>
            {showDialog && (
                <ColorPicker
                    value={color}
                    open={showDialog}
                    onChange={(v) => {
                        setShowDialog(false);
                        setColor(v);
                        props.onChange(v);
                    }}
                    onClose={() => setShowDialog(false)}
                />
            )}
        </>
    );
};
